/**
 * Min and max estate duty rates values
 */
export const MIN_ESTATE_DUTY_RATE = 20;
export const MAX_ESTATE_DUTY_RATE = 25;
